import { HttpClient } from '@/shared/lib/http-client';

export const fetchActivityTypes = async () => {
  const response = await HttpClient.get('/activity-types', {});
  return response.data;
};
